<template>
  <div>
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      v-loading="isBusy"
      element-loading-spinner="el-icon-loading"
      label-width="170px"
    >
      <el-form-item prop="send_list_id" label-width="auto">
        <el-select
          v-model="form.send_list_id"
          filterable
          clearable
          remote
          placeholder="Search Group"
          :remote-method="search"
          :loading="loading"
          class="form-control"
          @input="onInput"
          popperClass="custom-popper">
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="format(item)"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <button class="btn btn-purple px-4 mt-5" @click.prevent="store">Move</button>
    </el-form>
  </div>
</template>

<script>
  import BaseForm from '../form';
  import {addQueryParams} from "../../libs/url";

  export default {
    extends: BaseForm,

    props: {
      searchUrl: String,
      url: String,
      brandId: Number,
    },

    data() {
      const form = {
        send_list_id: null,
      };

      return {
        form,
        rules: _.mapValues(form, () => [{validator: this.fieldExternalValidator}]),
        options: [],
        loading: false,
      };
    },

    methods: {
      /**
       * @param {String} text
       */
      search(text) {
        this.loading = true;
        const url = addQueryParams(this.searchUrl, {
          search: text,
          brand_id: this.brandId,
        });

        axios.get(url)
          .then(this.onSuccess)
          .catch(this.onError)
          .finally(() => {
            this.loading = false;
          })
      },

      /**
       * @return {Object}
       */
      getForm() {
        return _.assign({}, this.form, {
          _method: this.method,
        });
      },

      /**
       * @param {object} data
       */
      onSuccess({data}) {
        this.options = _.get(data, 'data');
      },

      /**
       * @param {object} response
       */
      onError({response}) {
        this.options = [];
      },

      /**
       * @param {Object} item
       * @return {string}
       */
      format(item) {
        return _.get(item, 'name');
      },

      /**
       * @param {*} value
       */
      onInput(value) {
        this.$emit('input', value || null);
      },
    },
  }
</script>

<style scoped>

</style>
